import type { IClickedElement } from '../../types';

export const MOCK_CLICKED_ELEMENTS: IClickedElement[] = [
  {
    hash: '5ogc7wjr4.5ogc7wjr4',
    selector: ['Browse our latest product', 'btn-browse', 'btn btn-primary', 'button'],
    totalClicks: 31,
    totalOrders: 1,
    totalRevenue: 100,
    totalSessions: 100,
    totalSessionsThatCompletedCheckout: 0.0003,
  },
  {
    hash: '5ost39qwm.5ost39qwm',
    selector: ['', 'nav-products', 'nav-link', 'a'],
    totalClicks: 2,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 2,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '8oyrtc4vp.8oyrtc4vp',
    selector: ['Products View all', '', 'collection-grid', 'div'],
    totalClicks: 4,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 4,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '7u4v7715.7u4v7715',
    selector: ['Ducky GemX ▫▫', 'site-logo', 'logo', 'a'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: 'ba5srs3q.ba5srs3q',
    selector: ['Home', 'nav-home', 'nav-link active', 'a'],
    totalClicks: 2,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 2,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '246tbdznh.246tbdznh',
    selector: ['Home', 'breadcrumb-home', 'breadcrumb-item', 'a'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '246tbdznf.246tbdznf',
    selector: ['Contact', 'nav-contact', 'nav-link', 'a'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '65ce2v3hh.65ce2v3hh',
    selector: ['Home Catalog Contact USD ', 'main-nav', 'header-nav', 'nav'],
    totalClicks: 2,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 2,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '70o7u6pcf.70o7u6pcf',
    selector: ['Open region and language ', 'region-selector', 'localization-btn', 'button'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '4fu1qc9pt.4fu1qc9pt',
    selector: ['USD', 'currency-usd', 'currency-option', 'span'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '2soqcsven.2soqcsven',
    selector: ['', 'search-icon', 'icon', 'svg'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '157qycyj4.157qycyj4',
    selector: ['Search Clear View all', 'search-modal', 'modal-content', 'div'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: 'e3a4oi1h.e3a4oi1h',
    selector: ['Total items in cart: ▫ ▫', 'cart-icon', 'cart-count-bubble', 'a'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '97ombaar.97ombaar',
    selector: ['Your cart is empty Have a', 'cart-drawer', 'cart-drawer-content', 'div'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: 'lr72ozws.lr72ozws',
    selector: ['Gift card that shows text', 'product-card-1', 'product-card', 'div'],
    totalClicks: 6,
    totalOrders: 1,
    totalRevenue: 100,
    totalSessions: 6,
    totalSessionsThatCompletedCheckout: 0.028333333333333335,
  },
  {
    hash: 'lr72ozwn.lr72ozwn',
    selector: ['Top and bottom view of a ', 'product-card-2', 'product-card', 'div'],
    totalClicks: 5,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 5,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: 'lr72ozwo.lr72ozwo',
    selector: ['Top and bottom view of a ', 'product-card-3', 'product-card', 'div'],
    totalClicks: 4,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 4,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: 'lr72ozwr.lr72ozwr',
    selector: ['A bar of golden yellow wa', 'product-card-4', 'product-card', 'div'],
    totalClicks: 2,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 2,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '470adkuif.470adkuif',
    selector: ['Products View all Gift Ca', 'products-section', 'collection-list', 'section'],
    totalClicks: 14,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 14,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '5hq9pp1su.5hq9pp1su',
    selector: ['View all', 'view-all-btn', 'btn-link', 'a'],
    totalClicks: 2,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 2,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: 'lr72ozwj.lr72ozwj',
    selector: ['Top and bottom view of a ', 'product-card-5', 'product-card', 'div'],
    totalClicks: 3,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 3,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '5gddx63dr.5gddx63dr',
    selector: ['Add Added Add The Complet', 'add-to-cart-1', 'btn-add-cart', 'button'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '1to3oqgnl.1to3oqgnl',
    selector: ['The Complete Snowboard', 'product-title-1', 'product-title', 'h3'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '1y4f4tm8v.1y4f4tm8v',
    selector: ['$885.95', 'price-1', 'product-price', 'span'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '5gddx63dt.5gddx63dt',
    selector: ['Add Added The Collection ', 'add-to-cart-2', 'btn-add-cart', 'button'],
    totalClicks: 2,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 2,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '384tjurq7.384tjurq7',
    selector: ['Join our email list Get e', 'newsletter-section', 'footer-newsletter', 'section'],
    totalClicks: 7,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 7,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '2z22k76zc.2z22k76zc',
    selector: ['Join our email list Get e', 'newsletter-form', 'email-signup', 'form'],
    totalClicks: 2,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 2,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '9ebwu6a3.9ebwu6a3',
    selector: ['Join our email list', 'newsletter-heading', 'section-heading', 'h2'],
    totalClicks: 3,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 3,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '6865m3i7s.6865m3i7s',
    selector: ['Get exclusive deals and e', 'newsletter-desc', 'section-description', 'p'],
    totalClicks: 2,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 2,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '3h9cyefm5.3h9cyefm5',
    selector: ['', 'email-input', 'form-control', 'input'],
    totalClicks: 3,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 3,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: 'lr72ozwp.2g6ldwtbw',
    selector: ['Top and bottom view of a ', 'product-card-6', 'product-card', 'div'],
    totalClicks: 4,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 4,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: 'lr72ozwq.lr72ozwq',
    selector: ['Top and bottom view of a ', 'product-card-7', 'product-card', 'div'],
    totalClicks: 4,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 4,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '5otr2pu5x.5otr2pu5x',
    selector: ['Welcome to our store', 'hero-heading', 'hero-title', 'h1'],
    totalClicks: 2,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 2,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '5h0isre21.5h0isre21',
    selector: ['Welcome to our store', 'hero-section', 'banner-hero', 'section'],
    totalClicks: 2,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 2,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '6ic864jku.6ic864jku',
    selector: ['Welcome to our store { "@', 'hero-json-ld', 'structured-data', 'script'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '1cwodpici.1cwodpici',
    selector: ['Gift Card Add Added Add G', 'gift-card-section', 'product-grid', 'div'],
    totalClicks: 4,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 4,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: 'lr72ozwk.lr72ozwk',
    selector: ['Top and bottom view of a ', 'product-card-8', 'product-card', 'div'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
  {
    hash: '3w0upq4hj.3w0upq4hj',
    selector: ['Added', 'added-indicator', 'btn-success', 'span'],
    totalClicks: 1,
    totalOrders: 0,
    totalRevenue: 0,
    totalSessions: 1,
    totalSessionsThatCompletedCheckout: 0,
  },
];
